import React from "react";
import { TableCell, TableSortLabel } from "@mui/material";
import TableHeader from "@crema/core/AppTable/TableHeader";
import { UserData } from "types/models/master/MasterApp";

interface TableHeadingProps {
  order: "asc" | "desc";
  orderBy: keyof UserData | "roleName";
  onSort: (property: keyof UserData | "roleName") => void;
}

const COLUMN_WIDTH = 200;

const commonCellStyle = {
  fontSize: 14,
  width: COLUMN_WIDTH,
  maxWidth: 180,
  minWidth: 160,
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
  padding: 8,
};

const TableHeading: React.FC<TableHeadingProps> = ({ order, orderBy, onSort }) => {
  const createSortHandler = (property: keyof UserData | "roleName") => () => {
    onSort(property);
  };

  return (
    <TableHeader>
      <TableCell align="left" sx={commonCellStyle}>
        Action
      </TableCell>

      <TableCell
        align="left"
        sx={commonCellStyle}
        sortDirection={orderBy === "name" ? order : false}
      >
        <TableSortLabel
          active={orderBy === "name"}
          direction={orderBy === "name" ? order : "asc"}
          onClick={createSortHandler("name")}
        >
          Name
        </TableSortLabel>
      </TableCell>

      <TableCell
        align="left"
        sx={commonCellStyle}
        sortDirection={orderBy === "username" ? order : false}
      >
        <TableSortLabel
          active={orderBy === "username"}
          direction={orderBy === "username" ? order : "asc"}
          onClick={createSortHandler("username")}
        >
          User Name
        </TableSortLabel>
      </TableCell>

      <TableCell
        align="left"
        sx={commonCellStyle}
        sortDirection={orderBy === "roleName" ? order : false}
      >
        <TableSortLabel
          active={orderBy === "roleName"}
          direction={orderBy === "roleName" ? order : "asc"}
          onClick={createSortHandler("roleName")}
        >
          Role
        </TableSortLabel>
      </TableCell>

      <TableCell
        align="left"
        sx={commonCellStyle}
        sortDirection={orderBy === "contactNo" ? order : false}
      >
        <TableSortLabel
          active={orderBy === "contactNo"}
          direction={orderBy === "contactNo" ? order : "asc"}
          onClick={createSortHandler("contactNo")}
        >
          Contact No
        </TableSortLabel>
      </TableCell>

      <TableCell
        align="left"
        sx={commonCellStyle}
        sortDirection={orderBy === "email" ? order : false}
      >
        <TableSortLabel
          active={orderBy === "email"}
          direction={orderBy === "email" ? order : "asc"}
          onClick={createSortHandler("email")}
        >
          Email
        </TableSortLabel>
      </TableCell>

      <TableCell
        align="left"
        sx={commonCellStyle}
        sortDirection={orderBy === "SRCode" ? order : false}
      >
        <TableSortLabel
          active={orderBy === "SRCode"}
          direction={orderBy === "SRCode" ? order : "asc"}
          onClick={createSortHandler("SRCode")}
        >
          SR Code
        </TableSortLabel>
      </TableCell>

      <TableCell
        align="left"
        sx={commonCellStyle}
        sortDirection={orderBy === "IsActive" ? order : false}
      >
        <TableSortLabel
          active={orderBy === "IsActive"}
          direction={orderBy === "IsActive" ? order : "asc"}
          onClick={createSortHandler("IsActive")}
        >
          Status
        </TableSortLabel>
      </TableCell>
    </TableHeader>
  );
};

export default TableHeading;
